import { AppRoute } from '~/config';

export const routesToDisableForSnowflake = [
  AppRoute.STATUS,
  AppRoute.IAM_POLICY_STREAM,
  AppRoute.CHAOS_ENGINEERING,
  AppRoute.EXTENSIONS_MANAGE,
  AppRoute.STACK_OVERVIEW,
];
